var h="http://127.0.0.1:4000/graphql";export{h as FUEL_NETWORK_URL};
//# sourceMappingURL=configs.mjs.map